export default function Sidebar() {
  const items = ["Dashboard", "AI Chat", "Inventory", "Orders", "Clients", "Settings"];

  return (
    <div className="w-60 bg-black text-white min-h-screen p-4">
      <h1 className="text-xl font-bold mb-6">SolGuruz</h1>

      {items.map((item, i) => (
        <div
          key={i}
          className="p-2 rounded hover:bg-gray-800 cursor-pointer mb-2"
        >
          {item}
        </div>
      ))}
    </div>
  );
}